import { k as ensure_array_like, b as attr, e as escape_html, l as bind_props, p as pop, a as push, h as head } from "../../../../chunks/index2.js";
function DocViewer($$payload, $$props) {
  push();
  let {
    docId,
    pageCount = void 0,
    watermark = "",
    licenseEndpoint = "/api/license",
    pageEndpoint = "/api/page"
  } = $$props;
  let pages = [];
  $$payload.out.push(`<div class="viewer svelte-1b7ln86" role="application" aria-label="Secure document viewer"><div class="toolbar svelte-1b7ln86"><div class="title svelte-1b7ln86">View-only mode</div> <div class="hint svelte-1b7ln86">No download. Watermark applied.</div></div> `);
  if (pageCount) {
    $$payload.out.push("<!--[-->");
    const each_array = ensure_array_like(pages);
    $$payload.out.push(`<div class="pages svelte-1b7ln86"><!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let p = each_array[$$index];
      $$payload.out.push(`<div class="page-container svelte-1b7ln86"${attr("data-page", p.index)}><canvas${attr("id", `page-${p.index}`)} class="page-canvas svelte-1b7ln86"${attr("aria-label", `Page ${p.index}`)}></canvas> `);
      if (p.status === "loading") {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<div class="status svelte-1b7ln86">Loading…</div>`);
      } else {
        $$payload.out.push("<!--[!-->");
      }
      $$payload.out.push(`<!--]--> `);
      if (p.status === "error") {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<div class="status error svelte-1b7ln86">${escape_html(p.error)}</div>`);
      } else {
        $$payload.out.push("<!--[!-->");
      }
      $$payload.out.push(`<!--]--></div>`);
    }
    $$payload.out.push(`<!--]--></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<div class="status svelte-1b7ln86">Preparing viewer…</div>`);
  }
  $$payload.out.push(`<!--]--></div>`);
  bind_props($$props, { pageCount });
  pop();
}
function _page($$payload, $$props) {
  let data = $$props["data"];
  const { pageCount, watermark, docId } = data;
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Secure Viewer</title>`;
    $$payload2.out.push(`<meta name="robots" content="noindex,nofollow"/>`);
  });
  if (docId) {
    $$payload.out.push("<!--[-->");
    DocViewer($$payload, { pageCount, docId, watermark });
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<p>Invalid document id.</p>`);
  }
  $$payload.out.push(`<!--]-->`);
  bind_props($$props, { data });
}
export {
  _page as default
};
